import {
  ApolloLink,
  fromPromise,
  type FetchResult,
  type NextLink,
  type Observable,
  type Operation,
} from "@apollo/client";

export class TimeoutLink extends ApolloLink {
  constructor(private timeout: number = 60000) {
    super();
  }

  request(
    operation: Operation,
    forward?: NextLink | undefined,
  ): Observable<FetchResult> {
    return fromPromise(
      new Promise((resolve, reject) => {
        const controller = new AbortController();
        const signal = controller.signal;
        const context = operation.getContext() ?? {};
        const timeout = context.timeout ?? this.timeout;
        const timer = setTimeout(() => {
          const errorMessage = `Request timed out after ${timeout}ms for operation: ${operation.operationName}`;
          console.error(`[apollo-client]: ${errorMessage}`);
          controller.abort(errorMessage);
        }, timeout);

        operation.setContext({
          fetchOptions: {
            ...context.fetchOptions,
            signal,
          },
        });

        forward?.(operation)?.subscribe({
          next: (data) => {
            clearTimeout(timer);
            resolve(data);
          },
          error: (error) => {
            clearTimeout(timer);
            reject(error);
          },
          complete: () => {
            clearTimeout(timer);
          },
        });
      }),
    );
  }
}
